import type { ReactElement } from "react";
import { memo } from "react";

import { getLogoUrl } from "@/lib/logo";
import { cn } from "@/lib/utils";

import { useTheme } from "./ui/theme-provider";

interface ILogoProps {
  className?: string;
  wrapperClassName?: string;
  "data-testid"?: string;
}

const LogoComponent = ({
  className,
  wrapperClassName,
  "data-testid": dataTestId,
}: ILogoProps): ReactElement => {
  const { isOrgBrandingEnabled, logoCacheBusters } = useTheme();

  return (
    <div className={cn(wrapperClassName)} data-testid={dataTestId}>
      <img
        src={getLogoUrl({
          mode: "light",
          cacheBuster: logoCacheBusters.light,
          isOrgBrandingEnabled,
        })}
        alt="Logo Light"
        className={cn("dark:hidden", className)}
      />
      <img
        src={getLogoUrl({
          mode: "dark",
          cacheBuster: logoCacheBusters.dark,
          isOrgBrandingEnabled,
        })}
        alt="Logo Dark"
        className={cn("hidden dark:block", className)}
      />
    </div>
  );
};

export const Logo = memo(LogoComponent);
